export default __webpack_public_path__ + "static/Studio-To-Sea-Sub-Banner-Mobile-4476af3187749068d8f89a6134bd6f40.webp";